var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.07147 1.29102C5.21886 1.29102 2.0957 4.41418 2.0957 8.26679V16.5344C2.0957 20.387 5.21886 23.5101 9.07147 23.5101H17.3391C21.1916 23.5101 24.3148 20.387 24.3148 16.5344V8.26679C24.3148 4.41418 21.1916 1.29102 17.3391 1.29102H9.07147ZM17.8871 10.365C18.1898 10.0623 18.1898 9.57156 17.8871 9.26888C17.5844 8.96618 17.0937 8.96618 16.791 9.26888L12.01 14.0499C11.9091 14.1507 11.7455 14.1507 11.6447 14.0499L9.61954 12.0247C9.31685 11.722 8.82609 11.722 8.5234 12.0247C8.22072 12.3274 8.22072 12.8182 8.5234 13.1209L10.5485 15.1459C11.2547 15.8523 12.3999 15.8523 13.1062 15.1459L17.8871 10.365Z",
    fill: "#20A6D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/Checkbox.bbb26d7cf4e1b832832783a8e98444a4.svg";
export { ForwardRef as ReactComponent };